<template>
<div>
  <div class="delete-tier" @click="showDialog = true">-</div>
  <div v-if="showDialog" class="dialog-tier">
    <div class="container-message">
      <h3>Confirmación</h3>
      <div class="text">Se va a eliminar <span class="dark">1 producto <span class="uppercase">{{ nameProduct }}</span></span> del nivel <span class="dark">{{ tier }}</span> en la talla <span class="dark">{{ size }}</span> ¿Deseas continuar?</div>
      <div class="buttons">
          <shActionButton :action="close" text="No" textRunning="No" :principalColor="true"></shActionButton>
          <shActionButton :action="accept" text="Sí" textRunning="Sí"></shActionButton>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import mForm from '@/mixins/form'
import gqlStock from '@/graphql/stock'
import modals from '@my/store/modals'
import gql from '@my/graphql'

export default {
  name: 'DeleteTier',

  props: {
    nameProduct: { type: String, required: true },
    tier: { type: String, required: true },
    size: { type: String, required: true }
  },

  data () {
    return {
      showDialog: false
    }
  },

  mixins: [mForm],

  methods: {
    async accept () {
      const mutation = gqlStock.DELETE_OF_TIER

      if (!this.nameProduct || !this.size || !this.tier) return

      const response = await gql.mutate(mutation, { reference: this.nameProduct, size: this.size, quantity: 1, tier: this.tier })

      if (response && response.data && response.data.deleteOfTier) {
        modals.showMessage({ message: `Se ha eliminado un producto ${this.nameProduct} del nivel ${this.tier} en la talla ${this.size}` })
        this.$emit('deleted')
      }

      this.showDialog = false
    },

    close () {
      this.showDialog = false
    }
  }
}
</script>

<style>
.delete-tier {
  background-color: #f6f6f6;
  position: absolute;
  height: 1.5em;
  width: 1.5em;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  top: -.5rem;
  left: -.5rem;
  cursor: pointer;
  border: 1px solid #c8c8c8;
  z-index: 50;
  color: #000000;
}

.delete-tier:hover {
  background-color: #ff5968;
  color: #fff;
}

.dialog-tier {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);
  z-index: 200;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container-message {
  background-color: var(--background-principal);
  padding: 2em 3em;
  width: 100%;
  max-width: 40em;
  border-radius: 1.5em;
  color: #000000;
}
.container-message .text {
  margin: 0.5em 0 1em 0;
  font-size: 1.1em;
}
.container-message .buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
}

</style>



// WEBPACK FOOTER //
// src/components/ecommerce/DeleteTier.vue